import { Component, EventEmitter, OnInit } from '@angular/core';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';

@Component({
  selector: 'app-close-problem-modal',
  templateUrl: './close-problem-modal.component.html',
  styleUrls: ['./close-problem-modal.component.scss']
})
export class CloseProblemModalComponent implements OnInit {
  itemId?: number;
  public event: EventEmitter<any> = new EventEmitter();

  constructor(public bsModalRef: BsModalRef) { }

  ngOnInit(): void {
  }

  onCloseEvent(id) {
    this.event.emit(id);
  }

}
